import { Component } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Box, Card, SvgIcon } from "@mui/material";
import React from "react";
import { Modal } from 'react-bootstrap';
import { appContext } from "../../../../../AppContext";
import IbssTransferList from "../../../../../Components/Data/TransferList/IbssTransferList";
import IbssInputDropDown, { ISelectOption } from "../../../../../Components/Inputs/SelectList/IbssInputDropDown";
import IbssTextField from "../../../../../Components/Inputs/TextField/IbssTextField";
import IbssButton from "../../../../../Components/Buttons/Button/IbssButton";
import IbssFormControl from "../../../../../Components/Forms/FormControl/IbssFormControl";
import { IbssPage } from "../../../../../Components/Core/BasePage/IbssPage";
import CloseIcon from "../../../../../Components/Icons/CloseIcon";
import { PagedResponse } from "../../../../../Providers.Api/Models";
import { AssignedSpace, ISpace } from "./DataModels";
import LoadingOverlay from "../../../../../Components/Navigation/LoadingOverlay/LoadingOverlay";
import { getFloorUsingFloorId } from "../../../../../Common/Helper";


class AssignStoreToSpace extends IbssPage<IProps, IState>
{
    private get labels() { return appContext().labels; }
    private get localStorage() { return appContext().localStorageProvider; }
    private get appState() { return appContext().state; }
    private get apiCache() { return appContext().apiCache; }
    private equipmentStoreId: string;

    private transferListRef: React.RefObject<IbssTransferList>;
    constructor(props: IProps)
    {
        super(props);

        this.state =
        {
            allSpaces: [],
            assigningSpaces: false,
            showFilterModal: false,
            spaceTypeValue: null,
            floorValue: null,
            zoneValue: null,
            spaceLists: [],
            assignedSpaceList: [],
            filter:
            {
                searchText: null,
                spaceType: null,
                floor: null,
                zone: null
            }
        };

        this.equipmentStoreId = this.props.match.params.storeid
        this.transferListRef = React.createRef();
    }

    public async componentDidMount(): Promise<void>
    {
        this.pageTitle = this.labels.funcEquipmentStores_L
        const spacesData = await this.apiCache.getSpacesByBuilding(this.appState.buildingId);

        const Spaces: ISpace[] = spacesData.map(space => ({
            nodeId: space.Node_Id,
            spaceId: space.Space_Id,
            spaceType: space.Space_Type,
            spaceName: space.Space_Name,
            metaLocZone: space.Meta_Loc_Zone,
        }));

        this.setState({
            spaceLists: Spaces
        });

        await this.loadStoreAssignedSpaces();
        this.getAllSpaces();
    }

    private async loadStoreAssignedSpaces(): Promise<void> 
    {
        let skipToken = '';
        const allAssignedSpaces: ISpaceDetails[] = [];

        do 
        {
            const assignedSpaceResponse = await appContext().ibssApiClientV2.v2.byNodeid.spaces.bySpaceid.servicedSpacesByStore.get<PagedResponse<AssignedSpace[]>>({
                nodeId: this.appState.buildingId,
                spaceid: this.equipmentStoreId,
                select: AssignedSpace,
                top: 200,
                skipToken: skipToken
            });

            allAssignedSpaces.push(...assignedSpaceResponse.value.map(space => ({
                nodeId: space.Node_Id,
                spaceId: space.Space_Id,
                spaceName: space.Space_Name,
                spaceType: space.Space_Type,
                metaLocZone: space.Meta_Loc_Zone,
                floorName: getFloorUsingFloorId(space.Node_Id),
            })));

            skipToken = assignedSpaceResponse.skipToken || '';
        } while (skipToken);

        this.setState({ assignedSpaceList: allAssignedSpaces });
    }

    private getAllSpaces(): void
    {
        const availableSpaces = this.localStorage.getNodeData();
        const buildingData = availableSpaces.Regions.flatMap(region => region.Buildings).find(building => building.Node_Id === this.appState.buildingId);

        if (!buildingData) return;

        const buildingFloorIds = buildingData.Floors.map(floor => floor.Node_Id);
        const buildingSpaces = this.state.spaceLists.filter(space => buildingFloorIds.includes(space.nodeId));

        const spacesWithDetails = buildingSpaces.map(space => ({
            nodeId: space.nodeId,
            spaceId: space.spaceId,
            spaceType: space.spaceType,
            spaceName: space.spaceName,
            metaLocZone: space.metaLocZone,
            floorName: buildingData.Floors.find(floor => floor.Node_Id === space.nodeId)?.Node_Name || '',
        }) as ISpaceDetails);

        this.setState({ allSpaces: spacesWithDetails });
    }

    private formatSpacesForList(spaces: ISpaceDetails[]): IListItem[]
    {
        return spaces.map(space =>
            ({
                primaryText: `${space.spaceType}, ${space.spaceName}`,
                secondaryText: `${space.floorName} ${space.metaLocZone ? '|' : ''} ${space.spaceType}`,
            }) as IListItem);
    }

    private async saveClicked(): Promise<void>
    {
        const equipmentStoreId = this.equipmentStoreId;
        const transferListState = this.transferListRef.current?.state;
        const transferListRight = transferListState?.right.map(x => x.primaryText);
        const selectedIds = this.state.allSpaces.filter(x => transferListRight?.includes(`${x.spaceType}, ${x.spaceName}`)).map(x => x.spaceId);
        const storeFloorId = this.state.allSpaces.find(x => x.spaceId === equipmentStoreId)?.nodeId ?? 0;

        try
        {
            this.setState({ assigningSpaces: true });
            await appContext().ibssApiClientV2.v2.byNodeid.spaces.byStoreid.spacesToAssign.post({
                nodeId: storeFloorId,
                storeid: equipmentStoreId,
                body: selectedIds
            });
            this.props.history.goBack();
        }
        finally
        {
            this.setState({ assigningSpaces: false });
        }
    }

    private getDropDownValues(values: string[]): ISelectOption[]
    {
        let uniqueValues = values.filter((element: string, index: number) => (values.indexOf(element) === index));
        let filterOptions = uniqueValues.map(x => ({ value: x, label: x }))
        filterOptions = [{ label: this.labels.HubLabelAny, value: "Any" }, ...filterOptions]
        return filterOptions;
    };

    private async searchFilterChanged(value: string): Promise<void>
    {
        await this.setStateAsync({ filter: { ...this.state.filter, searchText: value } });
        this.filterStores()
    }

    private async filterStores(): Promise<void>
    {
        const { spaceTypeValue, floorValue, zoneValue } = this.state
        const transferListState = this.transferListRef;

        await this.setStateAsync({ filter: { ...this.state.filter, spaceType: spaceTypeValue === 'Any' ? null : spaceTypeValue, floor: floorValue === 'Any' ? null : floorValue, zone: zoneValue === 'Any' ? null : zoneValue } })
        let spaces = this.state.allSpaces;

        const filteredSpaces = spaces.filter(x =>
            (this.state.filter.spaceType ? x.spaceType == this.state.filter.spaceType : true)
            && (this.state.filter.floor ? x.floorName == this.state.filter.floor : true)
            && (this.state.filter.zone ? x.metaLocZone == this.state.filter.zone : true)
            && (this.state.filter.searchText ? x.spaceName.toLowerCase().includes(this.state.filter.searchText.toLowerCase()) : true)
        );

        this.setState({ showFilterModal: false });
        const transferListRightIds = transferListState.current?.state.right.map(x => x.id);
        transferListState.current?.setState({ left: this.formatSpacesForList(filteredSpaces.filter(x => !transferListRightIds?.includes(x.spaceId))), checked: [] });
    }


    public render(): JSX.Element
    {
        const defaultUnselectedSpaces = this.state.allSpaces.filter(space => !this.state.assignedSpaceList.some(assignedSpace => assignedSpace.spaceId == space.spaceId)); 
            return (
            <Box className="d-flex justify-content-center align-items-center page-height-exct-header">
                {
                    this.state.assigningSpaces ?
                        <Box className="rightPanel-main-content">
                            <Box className="text-ui-md">{this.labels.HubLabelAssigningSpacesMessage}</Box>
                            <Box style={{ position: 'relative', top: '40px' }}><LoadingOverlay /></Box>
                        </Box>
                        :
                        <Box className="rightPanel-main-content w-100">
                            <Card className="table-panel">
                                <Box>
                                    <Box className='d-flex'>
                                        <Box className='table-panel-header' style={{ paddingTop: '4px' }}>
                                            {this.labels.funcAssignSpaces_L}
                                        </Box>
                                    </Box>
                                    <Box className="table-panel-description">
                                        {this.labels.funcAssignSpacesSub_D}
                                    </Box>
                                    <Box className='d-flex mb-1'>
                                        <IbssTextField
                                            size="small"
                                            label={this.labels.HubLabelMySearchLabel}
                                            onChange={e => this.searchFilterChanged(e.target.value)}
                                            value={this.state.filter.searchText}
                                        />
                                        <Box style={{ alignSelf: 'center', paddingLeft: '8px' }}>
                                            <IbssButton
                                                fullWidth={false}
                                                style={{ minWidth: '100px', height: '40px' }}
                                                variant="contained"
                                                onClick={() => this.setState({ showFilterModal: true })}
                                            >
                                                {this.labels.HubLabelFilter}
                                            </IbssButton>
                                        </Box>
                                    </Box>
                                    <IbssTransferList
                                        ref={this.transferListRef}
                                        left={this.formatSpacesForList(defaultUnselectedSpaces)}
                                        right={this.formatSpacesForList(this.state.assignedSpaceList)}
                                        listWidth='auto'
                                        listHeight='60vh'
                                    />
                                </Box>
                            </Card>
                            <Box style={{ float: 'right', padding: '10px 0' }}>
                                <Box>
                                    <IbssButton
                                        disabled={this.state.assigningSpaces}
                                        style={{ minWidth: '100px' }}
                                        className='mr-2'
                                        variant="contained"
                                        color='secondary'
                                        onClick={() => this.props.history.goBack()}
                                    >
                                        {this.labels.HubButtonCancel}
                                    </IbssButton>
                                    <IbssButton
                                        disabled={this.state.assigningSpaces}
                                        style={{ minWidth: '100px' }}
                                        variant="contained"
                                        onClick={() => this.saveClicked()}
                                    >
                                        {this.labels.HubButtonSave}
                                    </IbssButton>
                                </Box>
                            </Box>
                            <Modal show={this.state.showFilterModal} onHide={() => this.setState({ showFilterModal: false })}>
                                <Modal.Header>
                                    <Modal.Title>{this.labels.HubLabelFilter}</Modal.Title>
                                    <Box display={"flex"} sx={{ cursor: "pointer" }} justifyContent={"flex-end"} >
                                        <SvgIcon onClick={() => this.setState({ showFilterModal: false })}>
                                            <CloseIcon />
                                        </SvgIcon>
                                    </Box>
                                </Modal.Header>
                                <Box style={{ paddingTop: '5px', paddingLeft: '58px' }} className="mb-4">
                                    {this.labels.HubLabelAssignPolicyFilterText}
                                </Box>
                                <Box style={{ paddingLeft: '59px' }}>
                                    <IbssFormControl style={{ width: '500px', paddingBottom: '8px' }} >
                                        <IbssInputDropDown
                                            onChange={e => { this.setState({ spaceTypeValue: e.target.value }) }}
                                            inputLabel={this.labels.HubLabelSpaceType}
                                            id='spaceType'
                                            options={this.getDropDownValues(this.state.allSpaces.map(x => x.spaceType).sort())}
                                            defaultValue={this.state.filter.spaceType ?? ''}
                                        />
                                    </IbssFormControl>
                                    <IbssFormControl style={{ width: '500px', paddingBottom: '8px' }} >
                                        <IbssInputDropDown
                                            onChange={e => { this.setState({ floorValue: e.target.value }) }}
                                            inputLabel={this.labels.HublabelFloor}
                                            id='floor'
                                            options={this.getDropDownValues(this.state.allSpaces.map(x => x.floorName))}
                                            defaultValue={this.state.filter.floor ?? ''}
                                        />
                                    </IbssFormControl>
                                    <IbssFormControl style={{ width: '500px', paddingBottom: '8px' }} >
                                        <IbssInputDropDown
                                            onChange={e => { this.setState({ zoneValue: e.target.value }) }}
                                            inputLabel={this.labels.HubLabelZone}
                                            id='zone'
                                            options={this.getDropDownValues(this.state.allSpaces.map(x => x.metaLocZone))}
                                            defaultValue={this.state.filter.zone ?? ''}
                                        />
                                    </IbssFormControl>
                                </Box>
                                <Modal.Footer>
                                    <Box style={{ textAlign: 'center' }}>
                                        <IbssButton
                                            style={{ height: '45px', minWidth: '100px' }}
                                            variant="contained"
                                            onClick={() => this.filterStores()}
                                        >
                                            {this.labels.HubLabelOk}
                                        </IbssButton>
                                    </Box>
                                </Modal.Footer>
                            </Modal>
                        </Box>
                }
            </Box>
        )
    }
}

export default AssignStoreToSpace;

export interface IProps extends RouteComponentProps<IQueryParams> 
{
}

export interface IQueryParams
{
    storeid: string;
}

export interface IState
{
    allSpaces: ISpaceDetails[],
    spaceTypeValue: string | null,
    floorValue: string | null,
    zoneValue: string | null,
    filter: IFilter,
    assigningSpaces: boolean,
    showFilterModal: boolean
    spaceLists: ISpace[],
    assignedSpaceList: ISpaceDetails[],
}

interface IListItem
{
    primaryText: string,
    secondaryText: string,
}

interface ISpaceDetails
{
    nodeId: number,
    spaceId: string,
    spaceType: string,
    spaceName: string,
    metaLocZone: string,
    floorName: string,
}

interface IFilter
{
    searchText: string | null,
    spaceType: string | null,
    floor: string | null,
    zone: string | null,
}

